"use client";

import { SearchX } from "lucide-react";
import { useParams } from "next/navigation";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export default function ProjectNotFoundState({
  className,
}: {
  className?: string;
}) {
  const { pid } = useParams<{ pid: string }>();
  const [report, setReport] = useState<"idle" | "sending" | "sent">("idle");

  async function reportMissing() {
    setReport("sending");
    try {
      await fetch("/api/report-missing-project", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pid, page: window.location.href }),
      });
    } catch {}
    // Thanks either way: the viewer can't do anything about a failed report.
    setReport("sent");
  }

  return (
    <div
      className={cn(
        "flex h-full w-full flex-col items-center justify-center gap-4 bg-background px-6 text-center",
        className,
      )}
    >
      <div className="rounded-full border border-muted-foreground p-4">
        <SearchX className="h-10 w-10 text-muted-foreground" />
      </div>
      <p className="text-lg font-medium text-muted-foreground">
        Project not found
      </p>
      {report === "sent" ? (
        <p className="text-sm text-muted-foreground">
          Thanks for your feedback.
        </p>
      ) : (
        <Button
          variant="link"
          size="sm"
          className="text-muted-foreground"
          disabled={report === "sending"}
          onClick={reportMissing}
        >
          I swear this project exists
        </Button>
      )}
    </div>
  );
}
